import React, { useState, useRef, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import appUrl from '../../../../constants/appUrl';
import axios from 'axios';
import { confirmDialog } from 'primereact/confirmdialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddEditAdmin from '../components/add_edit_admin';
import { InputText } from 'primereact/inputtext';

import { FilterMatchMode } from "primereact/api";
import Loader from '../../../components/loader';
const Admin = () => {
    const [rowselect, setRowselect] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dialog, setDialog] = useState();
    const [adminList, setAdminList] = useState();
    const [mustChangePasswordState, setMustChangePassword] = useState();
    const [res, setRes] = useState(false);
    const dt = useRef(null);
    const [editable, setEditable] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const GetAdmin = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${appUrl.baseUrl}/api/Admin/list`, {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`,
                  'Content-Type': 'application/json'
                }
              });
            const data = await response.json();
            setAdminList(data?.data)
            setLoading(false);
        } catch (error) {

        }
    }
    const onHide = () => {
        setDialog(false)
    }
    const confirm = (rowData) => {
        confirmDialog({
            header: (
                <div className="custom-header mb-3 mt-3">
                    {/* <i className="pi pi-trash custom-btn-delete"></i> */}

                </div>
            ),
            message: (
                <strong>Are you sure you want to delete this Admin?</strong>
            ),
             accept: () => accept(rowData),
            reject: () => reject(rowData),
            acceptClassName: 'custom-btn-red',
            rejectClassName: 'custom-white-red',
            className: 'center-buttons no-close-button',
        })
    }
    
    const editAction = (rowData) => {
        setEditable(true);
        setRowselect(rowData);
        setDialog(true);
    };
    const accept= async (rowData)=>{
        try{
            const response = await axios.delete(`${appUrl.baseUrl}/api/Admin/${rowData?.id}`,{
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
            setRes(response.data);
            toast.success("Deleted Successfully");
        }
        catch(error){

        }
    }
    const reject = (rowData) => {
        return
    }
    const actionTemplate = (rowData) => (
        <div>
            <Button icon="pi pi-pencil" className="custom-btn-edit" onClick={()=>{editAction(rowData)}} />
            {/* <Button icon="pi pi-trash" className="custom-btn-delete" onClick={() => { confirm(rowData) }} /> */}
        </div>
    );

    const exportCSV = () => {
        dt.current.exportCSV();
      }
    
    useEffect(() => {
        GetAdmin()
    }, [res])

    const mustChangePassword = localStorage.getItem('mustChangePassword');
    console.log("mustChangePassword", mustChangePassword)
    useEffect(() => {
        setMustChangePassword(mustChangePassword);
    }, [mustChangePassword])

    return (
        <>
          <ToastContainer />
            <Dialog visible={dialog} onHide={onHide}
                 header={editable ? "Edit Admin" : "Add Admin"}
                //header="Add Admin"
                style={{ width: "50vw" }}>
                <AddEditAdmin dialog={dialog} editable={editable} rowData={rowselect} setDialog={setDialog} onHide={onHide} setRes={setRes} />
            </Dialog>


            <Dialog visible={mustChangePasswordState} onHide={onHide}
                 header={editable ? "Edit Admin" : "Add Admin"}
                //header="Add Admin"
                style={{ width: "50vw" }}>
                <AddEditAdmin dialog={dialog} editable={editable} rowData={rowselect} setDialog={setDialog} onHide={onHide} setRes={setRes} />
            </Dialog>

            <div className='card'>
                <div className='grid'>
                <div className='md:col-2'>
                    <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                        <InputText className="w100" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                        </span>
                    </div>
                    <div className="md:col-6" ></div>
                    <div className="md:col-2" >
                    <Button className='custom-btn w100' label="Export to Excel" iconPos="right" onClick={exportCSV} />
                    </div>
                    
                    <div className="md:col-2" >
                        <div >
                            <Button className="custom-btn w100 " label="+ &nbsp;Add New"  onClick={() => { setEditable(false); setDialog(true) }}  />
                        </div>
                    </div>
                    {/* {loading && <Loader />} */}
                    <div className='md:col-12' >
                 
                        <DataTable
                            value={adminList}
                            scrollable
                            scrollHeight="450px"
                            paginator
                            rows={10}
                            ref={dt}
                            filters={filters} 
                            globalFilterFields={["name", "userName", "mobileNumber"]}
                        >
                            <Column field='name' header="Name" />
                            <Column field='mobileNumber' header="Mobile Number" />
                            <Column field='createdDate' header="Created Date"
                            body={(rowData) => new Date(rowData.createdDate).toLocaleString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                })} />
                            <Column field='modifiedDate' header="Modified Date"
                            
                            body={(rowData) => {
                                if (!rowData.modifiedDate) {
                                    return '-';
                                }
                                return new Date(rowData.modifiedDate).toLocaleString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                });
                            }}
                            />
                            <Column field='' header="Action" body={actionTemplate} style={{ minWidth: '12rem' }} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Admin